import { CdcService } from 'src/app/shared/services/cdc.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuperComponent } from '../../super/super.component';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent extends SuperComponent implements OnInit {
  BranchesThatPending:any = [];

    hrCards: any[] = [];
  accountantCards: any[] = [];
  stockCards: any[] = [];
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;
  constructor(Objects: ObjectsService,private router: Router ,translate: TranslateService, gt: genericCustomStoreService ,private CdcService:CdcService) { 
    super(Objects, translate, gt)    
  }

  ngOnInit(): void {
    this.GetBranchesRequestsThatPending();
  }
onRowClick(e:any) {
  debugger
  this.gt.$filterstatus.next(e.status);
  // console.log("Click Notification", e);
  // this.gt.update("CDCStatistics/Update", {filteration: e.filteration}).subscribe({next:(res: any)=>{}});
  this.router.navigate([e.url])
}

  GetBranchesRequestsThatPending() {
    this.CdcService.getCdcStatistics().subscribe((res:any)=> {
      this.BranchesThatPending = res
          this.hrCards = this.BranchesThatPending.filter((x:any) => x.type === 1);
    this.accountantCards = this.BranchesThatPending.filter((x:any) => x.type === 2);
    this.stockCards = this.BranchesThatPending.filter((x:any) => x.type === 3);
      //console.log('BranchesThatPending' , res)
    })
  }
 
}
